import React from "react";
import DocTyper from "../DocTyper/DocTyper";


const htmlEditorNewRouteTestPage = () => {
  return (
    <div className="w-100 d-flex justify-content-center mt-4">
      <div className="w-75 h-75">
        <DocTyper />
      </div>
    </div>
  );
};

export default htmlEditorNewRouteTestPage;
